import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { slugify } from "../../utils";
import SidebarTag from "../sidebar/sidbar-tag";
import BlogData from "../../data/blog.json";
import SocialIcon from "../social-icon";

const NewsDetailsWrap = ({ data }) => {
    return (
        <div className="blog-details-wrap">
            <div className="blog-details-thumb">
                <img
                    src={`${process.env.PUBLIC_URL}/${data.media.largeImage}`}
                    alt=""
                    // onError={(e) => {
                    //     e.currentTarget.src = "";
                    // }}
                />
            </div>
            <p className="blog-details-meta">
                <Link className="author" to="#">
                    {data.author}
                </Link>
                <span className="separator">-</span>
                <Link
                    className="date"
                    to={
                        process.env.PUBLIC_URL +
                        `/news-date/${slugify(data.date)}`
                    }
                >
                    {data.date}
                </Link>
            </p>

            <h2 className="blog-details-title" id="heading">
                {data.title}
            </h2>
            {data.body.map((single, key) => {
                return (
                    <div
                        className="desc"
                        key={key}
                        dangerouslySetInnerHTML={{ __html: single }}
                    ></div>
                );
            })}
            {data?.externalLink ? (
                <a
                    href={
                        data.externalLink.includes("http")
                            ? data.externalLink
                            : `${process.env.PUBLIC_URL}/${data.externalLink}`
                    }
                    target="_blank"
                    rel="noreferrer"
                    aria-labelledby="heading"
                    id="link"
                >
                    Click here to read more…
                </a>
            ) : (
                ""
            )}
            <div className="social-tags d-sm-flex justify-content-between align-items-center">
                {/* <p className="mb-4 mb-sm-0 d-flex align-items-center">
                    <i className="fa fa-tags"></i>
                    <SidebarTag data={BlogData} />
                </p>

                <ul className="social-links d-flex">
                    <li className="share">
                        <span>Share</span>
                    </li>
                    <li>
                        <SocialIcon
                            classOption="null"
                            path="https://www.facebook.com/"
                            icon="icofont-facebook"
                        />
                    </li>
                    <li>
                        <SocialIcon
                            classOption="null"
                            path="https://www.twitter.com/"
                            icon="icofont-twitter"
                        />
                    </li>
                    <li>
                        <SocialIcon
                            classOption="null"
                            path="https://www.instagram.com/"
                            icon="icofont-instagram"
                        />
                    </li>
                </ul> */}
            </div>
        </div>
    );
};

NewsDetailsWrap.propTypes = {
    data: PropTypes.object,
};

export default NewsDetailsWrap;
